<div class="account-menu-wrapper">
  <div class="account-menu-items">
    <a
      *ngFor="let item of menuItems"
      routerLink="{{ item.routerLink }}"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: false }"
      class="account-menu-item"
      (click)="onMenuItemClick(item.routerLink)"
    >
      <svg-icon
        [svgPath]="item.icon"
        [attr.aria-label]="item.title | translate"
        class="account-menu-item-icon"
      ></svg-icon>
      <span class="account-menu-item-title">{{ item.title | translate }}</span>
    </a>
  </div>
</div>
